var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeWithoutBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5079 4.98145H6.49243L8.50019 10.3297L10.5079 4.98145Z",
    fill: "#A6F9FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6018 4.98145L8.98319 11.957L8.94019 12.0715L16.925 4.98145H11.6018Z",
    fill: "#A6F9FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39857 4.98145H0.0753174L8.06018 12.0715L5.39857 4.98145Z",
    fill: "#A6F9FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29187 0L5.75841 3.58383L8.22495 0H3.29187Z",
    fill: "#A6F9FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7749 0L11.2414 3.58383L13.708 0H8.7749Z",
    fill: "#A6F9FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50003 1.39551L6.71887 3.9835H10.2812L8.50003 1.39551Z",
    fill: "#A6F9FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39896 0.498047L0 3.98375H4.79791L2.39896 0.498047Z",
    fill: "#A6F9FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.601 0.498047L12.202 3.98372H16.9999L14.601 0.498047Z",
    fill: "#A6F9FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeWithoutBg);
export default __webpack_public_path__ + "static/media/badgeWithoutBg.532cd089449d3887b1359248ed01a0db.svg";
export { ForwardRef as ReactComponent };